import React from 'react';
import PropTypes from 'prop-types';
import { trackingURL } from '@xingternal/xing-tracking';
import { IconSearch } from '@xingternal/icons';
import { trackings } from '../../../tracking';
import { QueryItem } from '../QueryItem';
import { Section } from './components';
function QuerySuggestionsSection({ baseI, highlightedIndex, section: { items }, getItemProps, userId, }) {
    return (React.createElement(Section, { type: "query-suggestions" }, items.map(({ trackingToken, payload: { url, ...payload } }, i) => {
        const position = i + baseI;
        return (React.createElement(QueryItem, { key: trackingToken, icon: React.createElement(IconSearch, { width: 24, height: 24 }), getItemProps: getItemProps, data: {
                ...payload,
                url: trackingURL(url, 'query_result')(trackings),
                trackingToken,
                position,
                userId,
            }, isHighlighted: position === highlightedIndex }));
    })));
}
QuerySuggestionsSection.propTypes = {
    baseI: PropTypes.number.isRequired,
    highlightedIndex: PropTypes.number,
    getItemProps: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    section: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape({
            payload: PropTypes.shape({
                url: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired,
            }).isRequired,
            trackingToken: PropTypes.string.isRequired,
        })).isRequired,
    }).isRequired,
};
export default QuerySuggestionsSection;
//# sourceMappingURL=QuerySuggestions.js.map